import React from 'react';
import DatePicker from 'react-date-picker';
import { Col, Row } from 'reactstrap';

const ReleaseDateLabel = ({ status }) => {
  if (status !== 'ACCEPTED') {
    return (
      <p style={styles.status()}>Release Date:</p>
    );
  }
  return null;
};

const TemplateDatePickers = ({
  status,
  releaseDate,
  setTemplateReleaseDate,
}) => (
  <div style={styles.container}>
    {status === 'PENDING' && (
      <Row>
        <Col />
        <Col md={4} style={styles.col}>
          <ReleaseDateLabel status={status} />
        </Col>
        <Col style={styles.col}>
          <DatePicker
            format="dd/MM/yyyy"
            locale="fr-FR"
            onChange={setTemplateReleaseDate}
            showLeadingZeros
            value={releaseDate}
          />
        </Col>
        <Col />
      </Row>
    )}
  </div>
);

const styles = {
  container: {
    flex: 1,
  },
  col: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginVertical: 15,
  },
  status: (status) => {
    let color = 'black';
    if (status === 'ACCEPTED') color = 'green';
    if (status === 'REJECTED') color = 'red';
    return {
      color,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: 'unset',
      marginRight: 10,
    };
  },
};

export default TemplateDatePickers;



// WEBPACK FOOTER //
// ./src/components/templates-manager/template-components/TemplateDatePickers.js